
const Source = {
  DIRECT: 'direct',
  PROFILE: 'profile',
  PROVIDER: 'provider',
};

module.exports = Source;
